import Color from 'color';
import {KeysMap} from './types';

export const getColor = (color: string, dimmed: boolean, alpha = 0.2): string => {
    if (dimmed) {
        return Color(color)
            .alpha(alpha)
            .hsl()
            .string();
    }

    return color;
};

export const getLabel = (gameCode: string, keysMap: KeysMap = {}): string => {
    return String(keysMap[gameCode]) || gameCode;
};
